import React from 'react';
import { cn } from '@/utils';

interface LogoLoaderProps {
  className?: string;
  size?: number;
  progress?: number; // 0 to 100
}

export function LogoLoader({ className, size = 40, progress = 0 }: LogoLoaderProps) {
  // Convert progress to clip path value
  const clipValue = 100 - progress;
  
  return (
    <div 
      className={cn(
        'relative flex items-center justify-center',
        className
      )}
      style={{ width: size, height: size }}
    >
      <div className="logo-loader">
        <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
          <defs>
            <linearGradient id="brandGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: '#9333ea' }} />
              <stop offset="100%" style={{ stopColor: '#4f46e5' }} />
            </linearGradient>
          </defs>
          
          {/* White outline version */}
          <image
            href="/assets/icon.png"
            width="100"
            height="100"
            style={{
              filter: 'brightness(0) invert(1)',
              opacity: 0.3
            }}
          />
          
          {/* Colored fill version with clip path */}
          <g style={{ clipPath: `inset(0 ${clipValue}% 0 0)`, transition: 'clip-path 0.3s ease-out' }}>
            <image
              href="/assets/icon.png"
              width="100"
              height="100"
              style={{
                filter: 'url(#brandGradient)'
              }}
            />
          </g>
        </svg>
      </div>
      <style jsx>{`
        .logo-loader {
          position: relative;
          width: 100%;
          height: 100%;
        }
        
        image {
          transform-origin: center;
          transform: scale(0.8);
        }
      `}</style>
    </div>
  );
}
